import { SxProps, Theme } from '@mui/material';
import { DocumentReference } from '../../../context/DocumentFootnotesContext';
import { IWidget } from '../../Widgets/types';
import { DrawerSecondaryAction } from '../tab-drawer/models/navigation-config.interface';

export enum WidgetDrawerApplicationContext {
  CAP_TABLE = 'cap_table',
  CUSTOM_BREAKPOINTS = 'custom_breakpoints',
  FUND_OWNERSHIP = 'fund_ownership',
  FINANCIALS = 'financials',
  BACKSOLVE = 'backsolve',
  GPC = 'gpc',
  VALUATION_APPROACHES = 'valuation_approaches',
  DCF = 'dcf',
  EXTERNAL_VALUATION = 'external_valuation',
  FUTURE_EXIT = 'future_exit',
  SSV = 'ssv',
  TRANSACTION_COMPS = 'transaction_comps',
  WORKBOARD = 'workboard',
  FUND_INVESTMENT_SUMMARY = 'fund_investment_summary',
  FUND_INVESTMENT_MARKET_ADJUSTMENT = 'market_adjustment',
  WATERFALL = 'waterfall',
  RANGE_SENSITIVITY = 'range_sensitivity',
  CALIBRATION = 'calibration',
}

interface WidgetDrawerProps extends IWidget {
  applicationContext: WidgetDrawerApplicationContext;
  contentWrapperSx?: SxProps<Theme>;
  headerContentSx?: SxProps<Theme>;
  documentTabCustomActions?: DrawerSecondaryAction[];
  documentApplicationStorageKey?: string;
  documentSourceProps?: {
    documentCitations: Map<number, DocumentReference>;
    documentMetadata: Map<number, number>;
  };
  /**
   * Cap-table-scoped persistent panel held to the left of the active tab content
   * across tab changes. When omitted (valuations/financials), the drawer renders
   * exactly as before. Not rendered in export mode (the drawer is replaced by the
   * export relay there).
   */
  sidePanel?: React.ReactNode;
  /**
   * Optional node rendered in the drawer header row BEFORE the first tab (e.g. the
   * cap table's standalone pending-review badge, SCAL-9181). Normal flow - part of
   * the tab row, not a tab and not floating over content.
   */
  headerLeading?: React.ReactNode;
}

export default WidgetDrawerProps;
